<template>
  <div>
    <MapToDealerModal :companyId="companyId" />
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            borderRadius: '16px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.cDealers.totalDealer") }}
              </h3>
              <div class="text-center mt-3">
                <div class="dealer__icon__wrapper mt-3">
                  <div class="dealer__icon__div text-center">
                    <div>
                      <img src="@/assets/img/truck (1).png" width="80%" />
                    </div>
                  </div>
                </div>
                <h5 class="mt-3 primary_text">{{ dealerCount }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_dealer"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              borderRadius: '16px',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="align-items-center section__row">
              <div class="text-center section___column_1">
                <!-- <div>
                  <h3 class="our__branches__banner__title">
                    {{ $t("text.dealers.title") }}
                  </h3>
                </div> -->

                <div>
                  <button
                    @click="mapToDealer"
                    class="btn btn-light rounded-pill"
                  >
                    {{ $t("text.cDealers.mapButton") }}
                  </button>
                </div>
              </div>

              <!-- <div class="col-md-6 text-right section___column_2">
                <div class="row align-items-center">
                  <div class="row input__row___div">
                    <div class="col-md-2">
                      <img
                        src="@/assets/img/search.png"
                        height="25"
                        style="margin-top: 6px"
                      />
                    </div>
                    <div class="col-md-10">
                      <input
                        type="text"
                        :placeholder="$t('text.dealers.searchDealers')"
                        class="branches__search__input dealers_placeholder"
                      />
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <section class="dealers__section__row mt-3">
        <TableLoader :showLoader="showLoader" />
        <div style="width: 96%; margin-left: 15px" class="dealers__div">
          <div id="dealers" class="row">
            <div
              class="col-md-3 column__ text-center pb-4 dealer"
              v-for="(dealer, index) in dealers"
              :key="index"
            >
              <div class="deaLer__column_1 text-center">
                <h3 class="dealer__name__header">{{ dealer.name }}</h3>
                <div class="dealer__icon__wrapper">
                  <div class="dealer__icon__div text-center">
                    <div>
                      <img src="@/assets/img/placeholder (1).svg" width="80%" />
                    </div>
                  </div>
                </div>
                <h3 class="dealer__address__header mt-3">
                  {{ `${dealer.street}, ${dealer.city}` }}
                </h3>
                <p>{{ `${dealer.state}, ${dealer.country}` }}</p>
                <div
                  class="d-flex justify-content-between px-2"
                  :style="[{ paddingBottom: '11px' }]"
                >
                  <router-link
                    :to="{
                      name: 'dealer_details',
                      query: { dealerId: dealer.id },
                    }"
                    style="
                      text-decoration: none;
                      color: rgb(75, 44, 114);
                      width: auto;
                    "
                    class="details_btn"
                  >
                    {{ $t("text.dealers.details") }}
                  </router-link>
                  <router-link
                    :to="{
                      name: 'our_branches',
                      query: { dealerId: dealer.id },
                    }"
                    class="branches_btn text-white ml-2"
                    style="text-decoration: none; width: auto"
                    >{{ $t("text.dealers.branches") }}
                    <span>({{ dealer.numberOfBranches }})</span></router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->
      <section class="table_align_div mt-3">
        <div class="">
          <div class="position-relative">
            <!-- :dataBound="dataBound" -->
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="70" field="index" headerText="#"></e-column>
                <e-column
                  width="200"
                  field="name"
                  :headerText="$t('text.branch.name')"
                ></e-column>
                <e-column
                  width="400"
                  field="street"
                  :headerText="$t('text.dealerDetails.street')"
                ></e-column>
                <!-- <e-column
                  width="200"
                  field="state"
                  :headerText="$t('text.branch.state')"
                ></e-column> -->
                <e-column
                  width="300"
                  :template="DealersTemp"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
// import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import TableLoader from "@/components/tableLoader/index";
import configObject from "@/config";
import DealersTemp from "@/components/Templates/dealersTemp";
import MapToDealerModal from "@/components/modals/mapToDealerModal";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Dealers :: Epump Portal",
  name: "OurDealers",
  components: {
    MasterLayout,
    TableLoader,
    MapToDealerModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      corpId: null,
      backgroundUrl,
      cardBackgroundUrl,
      dealerId: null,
      showLoader: false,
      company: null,
      companyId: null,
      dealers: [],
      dealerCount: 0,
      numberOfBranches: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      DealersTemp: function () {
        return {
          template: DealersTemp,
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.Dealers();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      if (company) {
        this.companyId = company.id;
      }
    });
    if (this.$route.query.companyId) {
      this.Dealers();
    }
    this.showLoader = true;
  },
  mounted() {
    $(".branches__search__input").on("keyup", function () {
      var value = $(this).val().toLowerCase();
      $("#dealers .dealer").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
      });
    });
  },

  methods: {
    changeRoute($newRoute, id) {
      this.$router.push({ name: $newRoute, query: { dealerId: id } });
    },
    async Dealers() {
      const result = await this.getDealers();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    mapToDealer() {
      this.$modal.show("mapToDealerModal");
    },
    getDealers() {
      this.showLoader = true;
      return this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Dealers/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : -1;
          });
          response.data.forEach((element) => {
            element.index = ++index;
            // element.dateUnformatted = element.date;
          });
          this.showLoader = false;
          localStorage.setItem("dealers", JSON.stringify(response.data));
          this.dealers = response.data;
          this.dealerCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
          return response;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style>
.branches_btn:hover {
  text-decoration: none;
  color: white;
}
@media screen and (max-width: 768px) {
  input.branches__search__input.dealers_placeholder {
    position: relative;
    top: -82%;
    right: 7px;
  }
}
</style>
